import React from 'react'
import { injectIntl } from 'react-intl'
import { Body, Display } from 'shared-global-ec-uikit/components/dist/react/esm'
import Parser from 'html-react-parser'

const StoreTransportation = (props: any) => {
  const listOfItems = props.storeInfo[`${props.method}Access`]

  return (
    <>
      <Display
        color="primary-dark"
        element="p"
        maxLinesEllipsis={0}
        textAlign="left"
        textTransform="normal"
        variant="display4"
        className="fr-ec-mb-spacing-04"
      >
        {props.intl.formatMessage({ id: `text_${props.method}` })}
      </Display>
      <Body color="primary-dark" element="p" variant="standard">
        {Parser(listOfItems)}
      </Body>
    </>
  )
}

export default injectIntl(StoreTransportation)
